import React from 'react'
import { Form, Input } from 'antd'
/**
 * @prop config 属性设置
 */
export default class TempNumber extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { config } = this.props;
        return (
            <Form.Item label={config.title} name={config.field} >
                <Input type="number" placeholder={`请输入${config.title}`} />
            </Form.Item>
        )
    }
}
